// Runtime configuration, injected when the container starts rather than baked in at build time.
// docker-entrypoint.sh writes dist/runtime-config.js from the container env; locally the
// runtimeConfigPlugin in vite.config.js serves the same file from .env. index.html loads it
// before the app bundle, so window.__APP_CONFIG__ is always populated by the time this runs.
// Keep RUNTIME_CONFIG_KEYS in vite.config.js and docker-entrypoint.sh in sync with these keys.
const runtimeConfig = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

const REQUIRED_KEYS = ['API_BASE_URL', 'APP_BASE_URL'];

const missingKeys = REQUIRED_KEYS.filter(key => !runtimeConfig[key]);
if (missingKeys.length > 0) {
  throw new Error(
    `Missing required runtime config: ${missingKeys.join(', ')}. ` +
      'Check that /runtime-config.js is served and defines window.__APP_CONFIG__.'
  );
}

const DEFAULT_SENTRY_TRACES_SAMPLE_RATE = 0.5;

function toSampleRate(value) {
  const rate = Number.parseFloat(value);
  return Number.isFinite(rate) && rate >= 0 && rate <= 1 ? rate : DEFAULT_SENTRY_TRACES_SAMPLE_RATE;
}

export const APP_CONFIG = Object.freeze({
  API_BASE_URL: runtimeConfig.API_BASE_URL,
  APP_BASE_URL: runtimeConfig.APP_BASE_URL,
  // Optional: absent keys stay undefined so consumers can tell "not configured" apart.
  IMAGE_BASE_URL: runtimeConfig.IMAGE_BASE_URL || undefined,
  SITE_KEY: runtimeConfig.SITE_KEY || undefined,
  MIXPANEL_TOKEN: runtimeConfig.MIXPANEL_TOKEN || undefined,
  SENTRY_DSN: runtimeConfig.SENTRY_DSN || undefined,
  // MODE is build metadata; it only stands in when the environment doesn't name itself.
  SENTRY_ENVIRONMENT: runtimeConfig.SENTRY_ENVIRONMENT || import.meta.env.MODE,
  SENTRY_TRACES_SAMPLE_RATE: toSampleRate(runtimeConfig.SENTRY_TRACES_SAMPLE_RATE),
  USER_TYPE: runtimeConfig.USER_TYPE || undefined,
});
